import { Component, Input, output } from '@angular/core';
import { NgxButtonComponent } from '@digipay/ngx-button';

@Component({
  selector: 'app-notify-me',
  templateUrl: 'notify-me.component.html',
  styleUrls: ['notify-me.component.scss'],
  standalone: true,
  imports: [NgxButtonComponent],
})
export class NotifyMeComponent {
  @Input() loading: boolean;
  notifyMeClicked = output<boolean>();

  notifyMe() {
    this.loading = true;
    this.notifyMeClicked.emit(true);
  }
}
